import { getDomainUrl } from 'core/utils';
import { JobDetailsTab } from 'jobs/components/JobDetails';

export const jobListPath = () => '/job/list';
export const jobDetailsPath = (id: number | string = ':id', tab?: JobDetailsTab) => {
  const basePath = `/job/${id}`;

  return tab ? `${basePath}?tab=${tab}` : basePath;
};

export const oldBomPartListPath = (
  projectId: number | string = ':projectId',
  bomId: number | string = ':bomId'
) => `${getDomainUrl()}/bom/part/list?project=${projectId}&bom=${bomId}`;
